import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacesComponent } from './faces.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FacesTranslationComponent } from './faces-translation.component';
import { FacesTranslationService } from './faces-translation.service';



@NgModule({
  declarations: [FacesComponent, FacesTranslationComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
  ],
  providers:[FacesTranslationService],
  exports: [FacesComponent],
  entryComponents:[FacesTranslationComponent],
})
export class FacesModule { }
